import { z } from "zod";
import { MAX_SONG_DURATION_MS } from "../constants";
import { MEDIA_KINDS } from "../media";

export const SHA256_PATTERN = /^[0-9a-f]{64}$/;

export const sha256Schema = z.string().regex(SHA256_PATTERN);

/** Query string of a media upload. Kind and extension consistency is checked by the service. */
export const mediaUploadQuerySchema = z.object({
  kind: z.enum(MEDIA_KINDS),
  ext: z.string().trim().toLowerCase().min(1).max(8),
  sha256: sha256Schema,
  duration_ms: z.coerce.number().int().positive().max(MAX_SONG_DURATION_MS).optional(),
});

export type MediaUploadQuery = z.infer<typeof mediaUploadQuerySchema>;
